import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import ReactPlayer from 'react-player';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../CustomSwiper.css'; // Import your updated CSS

const FullScreenCarousel = ({ items, onClose }) => {
    // Helper function to check if the file is a video
    const isVideo = (url) => {
        const videoExtensions = ['mp4', 'mov', 'webm', 'ogg'];
        const extension = url.split('.').pop().toLowerCase();
        return videoExtensions.includes(extension);
    };

    return (
        <div className="fullscreen-carousel" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1000, backgroundColor: 'black' }}>
            {/* Close Button */}
            <div className="close-button" onClick={onClose}>
                &#10005;
            </div>

            <Swiper
                modules={[Navigation, Pagination]}
                navigation={true}
                pagination={{ clickable: true }}
                spaceBetween={50}
                slidesPerView={1}
                className="mySwiper"
            >
                {items.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div className="carousel-media-container" style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {/* Conditionally render an image or video based on the file type */}
                            {isVideo(item) ? (
                                <div className="carousel-video" style={{ width: '100vw', height: '100vh' }}>
                                    <ReactPlayer
                                        url={item}
                                        controls
                                        playing={false}
                                        width="100%"
                                        height="100%"
                                        className="react-player" // Optional class for further styling
                                    />
                                </div>
                            ) : (
                                <img
                                    src={item}
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                    alt={`Slide ${index + 1}`}
                                    className="carousel-image"
                                />
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default FullScreenCarousel;
